import '../styles/main.scss';

import { graphql } from 'gatsby';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { Module } from '../components/ModulesContent';
import { HeroType } from '../components/ui/Hero';
import ItemGridModule from '../components/ui/modules/ItemGridModule';
import { ALL_LANGS } from '../constants';
import { SanityImageType } from '../graphql-fragments/SanityImage';
import { LocalizedSEO } from '../graphql-fragments/seo';
import { withI18n } from '../utils/hocs';
import { getServicesAsBlocks } from '../utils/projectUtils';
import { localize } from '../utils/sanity';
import PageTemplate from './PageTemplate';

export const query = graphql`
  query GetServicePageById($id: String!) {
    sanityService(_id: { eq: $id }) {
      ...Service
    }
    allSanityService(sort: { orderRank: ASC }) {
      nodes {
        ...Service
      }
    }
  }
`;

export interface Service {
  _id: string;
  title: string;
  slug: {
    current: string;
  };
  hero: HeroType;
  description: string;
  icon: SanityImageType;
  modules?: Array<Module>;
  hideFormModule?: boolean;
  seo?: LocalizedSEO;
}

interface LocalizedQueryData {
  sanityService: Service;
  allSanityService: {
    nodes: Array<Service>;
  };
}

const ServicePage = ({ data }): React.ReactElement => {
  const { i18n, t } = useTranslation();

  const langs = [i18n.language, ...ALL_LANGS.filter(lang => lang !== i18n.language)];
  const localizedData: LocalizedQueryData = localize(data, langs);

  const { _id, title, description, hero } = localizedData.sanityService;

  const otherServices = localizedData.allSanityService.nodes.filter(service => service._id !== _id);

  const servicesAsGridItems = getServicesAsBlocks(otherServices);

  return (
    <PageTemplate
      page={localizedData.sanityService}
      description={description}
      defaultSEO={{
        defaultDescription: description,
        defaultTitle: title,
        defaultImageUrl: hero.desktopBackgroundImage?.asset.url,
      }}
      hardCodedModules={
        servicesAsGridItems.length > 0 && (
          <ItemGridModule
            title={t('service_page.other_services', 'Outros serviços')}
            items={servicesAsGridItems}
          />
        )
      }
    />
  );
};

export default withI18n(ServicePage);
